import { Link, LinkProps, useLocation } from "react-router-dom";
import { forwardRef, MouseEvent } from "react";

interface ScrollLinkProps extends LinkProps {
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
}

const ScrollLink = forwardRef<HTMLAnchorElement, ScrollLinkProps>(
  ({ to, onClick, children, ...props }, ref) => {
    const location = useLocation();
    const targetPath = typeof to === "string" ? to : to.pathname || "";

    const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
      // Always scroll to top, whether same page or different page
      if (location.pathname === targetPath) {
        // Same page - prevent default navigation and just scroll
        e.preventDefault();
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
      // For different pages, let the navigation happen normally
      // ScrollToTop component will handle the scroll after route change
      
      // Call the original onClick if provided
      onClick?.(e);
    };

    return (
      <Link ref={ref} to={to} onClick={handleClick} {...props}>
        {children}
      </Link>
    );
  }
);

ScrollLink.displayName = "ScrollLink";

export default ScrollLink;
